import { atom } from "jotai";

export interface IHeaderV2LayoutStoreBackButton {
  url: string;
  defaultBackUrl?: string;
  action?: () => void;
  replace?: boolean;
}

interface IHeaderV2LayoutStoreCloseButton {
  url?: string;
  modal?: JSX.Element;
}

export enum HeaderV2LayoutAction {
  notification = "notification",
  search = "search",
  chatWithOperator = "chatWithOperator",
  aiAssistant = "aiAssistant",
}

export interface IHeaderV2LayoutStore {
  backButton?: IHeaderV2LayoutStoreBackButton;
  closeButton?: IHeaderV2LayoutStoreCloseButton;
  showLogo?: boolean;
  showLogoOnMobile?: boolean;
  forceLogoExtended?: boolean;
  forceLogoCentered?: boolean;
  actions?: HeaderV2LayoutAction[];
}

export const headerV2LayoutStoreInitialState: IHeaderV2LayoutStore = {
  backButton: undefined,
  closeButton: undefined,
  showLogo: false,
  showLogoOnMobile: false,
  forceLogoExtended: false,
  forceLogoCentered: false,
  actions: [],
};

export const HeaderV2LayoutStore = atom(headerV2LayoutStoreInitialState);
